export default "__VITE_ASSET__$2CqDN8W__"